










import {defineComponent, PropType} from '@vue/composition-api'
import { Grade } from '../models/grades-viewmodel';

export default defineComponent({
  name: 'GradeComponent',
  props: {
    grade: {
      type: Object as PropType<Grade>
    }
  },
  setup: () => {
    function getDateFormat(date: string) {
      let date_ob = new Date(date);

      let day = ("0" + date_ob.getDate()).slice(-2);
      let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
      let year = date_ob.getFullYear();

      return `${day}-${month}-${year}`;
    }

    return {
      getDateFormat
    }
  }
})


